export type CensusSortBy =
  | 'clinic'
  | 'patient_first'
  | 'patient_last'
  | 'admission_date'
  | 'discharge_date'
  | 'episode_start_date'
  | 'episode_end_date'
  | 'episode_active'
  | 'mrn'
  | 'age'
  | 'sex'
  | 'language'
  | 'race'
  | 'address'
  | 'city'
  | 'state'
  | 'county'
  | 'zip_code'
  | 'phone';

/**
 * Array of all CensusSortBy values.
 */
export const CENSUSSORTBY_VALUES: readonly CensusSortBy[] = [
  'clinic',
  'patient_first',
  'patient_last',
  'admission_date',
  'discharge_date',
  'episode_start_date',
  'episode_end_date',
  'episode_active',
  'mrn',
  'age',
  'sex',
  'language',
  'race',
  'address',
  'city',
  'state',
  'county',
  'zip_code',
  'phone',
] as const;
